"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum;
(function (TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum) {
    TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum["StaticMaxNumber"] = "STATIC_MAX_NUMBER";
    TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum["CumulativePercentOfTotal"] = "CUMULATIVE_PERCENT_OF_TOTAL";
    TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum["IndividualPercentOfTotal"] = "INDIVIDUAL_PERCENT_OF_TOTAL";
})(TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum = exports.TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum || (exports.TableauQuillV1ContributorsConfigurationDriverThresholdTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum;
(function (TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum) {
    TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum["StaticMaxNumber"] = "STATIC_MAX_NUMBER";
    TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum["CumulativePercentOfTotal"] = "CUMULATIVE_PERCENT_OF_TOTAL";
    TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum["IndividualPercentOfTotal"] = "INDIVIDUAL_PERCENT_OF_TOTAL";
})(TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum = exports.TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum || (exports.TableauQuillV1ContributorsConfigurationOffsetterThresholdTypeEnum = {}));
function TableauQuillV1ContributorsConfigurationFromJSON(json) {
    return TableauQuillV1ContributorsConfigurationFromJSONTyped(json, false);
}
exports.TableauQuillV1ContributorsConfigurationFromJSON = TableauQuillV1ContributorsConfigurationFromJSON;
function TableauQuillV1ContributorsConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'driverThresholdType': !runtime_1.exists(json, 'driver_threshold_type') ? undefined : json['driver_threshold_type'],
        'driverThreshold': !runtime_1.exists(json, 'driver_threshold') ? undefined : json['driver_threshold'],
        'offsetterThresholdType': !runtime_1.exists(json, 'offsetter_threshold_type') ? undefined : json['offsetter_threshold_type'],
        'offsetterThreshold': !runtime_1.exists(json, 'offsetter_threshold') ? undefined : json['offsetter_threshold'],
        'detailSecondaryDimensions': !runtime_1.exists(json, 'detail_secondary_dimensions') ? undefined : json['detail_secondary_dimensions'],
    };
}
exports.TableauQuillV1ContributorsConfigurationFromJSONTyped = TableauQuillV1ContributorsConfigurationFromJSONTyped;
function TableauQuillV1ContributorsConfigurationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'driver_threshold_type': value.driverThresholdType,
        'driver_threshold': value.driverThreshold,
        'offsetter_threshold_type': value.offsetterThresholdType,
        'offsetter_threshold': value.offsetterThreshold,
        'detail_secondary_dimensions': value.detailSecondaryDimensions,
    };
}
exports.TableauQuillV1ContributorsConfigurationToJSON = TableauQuillV1ContributorsConfigurationToJSON;
